import { CarouselLabels } from './carousel-labels';

export const DEFAULT_LABELS: Required<CarouselLabels> = {
  regionLabel: 'Featured games',
  prevSlide: 'Previous slide',
  nextSlide: 'Next slide',
  goToSlide: 'Go to slide',
};

export const DEFAULT_AUTOPLAY_DELAY = 5000;
export const DEFAULT_TRANSITION_DURATION = 25;

export function resolveLabels(labels?: CarouselLabels): Required<CarouselLabels> {
  return { ...DEFAULT_LABELS, ...labels };
}

export interface MotionConfig {
  /** Whether the autoplay plugin should be attached. */
  autoplay: boolean;
  /** Embla scroll duration; 0 makes transitions instant. */
  duration: number;
}

/**
 * Pure mapping from the user's motion preference to carousel behaviour.
 * Extracted so the `prefers-reduced-motion` branch is unit-testable without
 * a DOM or Embla.
 */
export function resolveMotionConfig(reducedMotion: boolean): MotionConfig {
  return reducedMotion
    ? { autoplay: false, duration: 0 }
    : { autoplay: true, duration: DEFAULT_TRANSITION_DURATION };
}

/** Reads the OS-level reduced-motion preference, SSR-safe. */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
